<template>
    <div class="specialDetaidBox">
        <MaskLoading v-if="isShow"></MaskLoading>
        <!-- <banner :bannerList="bannerList"></banner> -->
        <img src="../../assets/special/db2.jpg" alt="" class="mobileImg" v-if="isMobile">
        <img src="../../assets/special/db2_pc.jpg" alt="" class="mobileImg" v-else>
        <!--  -->
        <div class="special_warpper">
            <div class="p20">
                <backSpecial></backSpecial>
                <div>
                    <div class="arrow_box mb20">
                        <div class="arrow_title">意外补贴的理赔流程</div>
                        <div class="pb20">
                            <img src="../../assets/special/d2t.jpg" alt="" style="width:100%;display: block;" v-if="isMobile">
                            <img src="../../assets/special/d2t_pc.jpg" alt="" style="width:100%;display: block;" v-else>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">保障內容</div>
                    <div class="table_box mb20">
                        <div class="tab_title_box">
                            <div class="tab_title">参保性质</div>
                            <div class="tab_title">报销形式</div>
                        </div>
                        <div class="table_info_box">
                            <div class="row_list">
                                <div class="tab_cell tab_link" @click="showDrawer(0)">家庭财产火灾损失保障</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">最高10000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell tab_link" @click="showDrawer(1)">家庭财产水暖管爆裂<br>损失保障</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">最高10000元</div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell tab_link" @click="showDrawer(2)">会员本人发生非工伤<br>意外事故导致身故残疾保障</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">
                                    <div class="tab_cell lh30 bb1">残疾最高5000元</div>
                                    <div class="tab_cell lh30">身故20000元</div>
                                </div>
                            </div>
                            <div class="row_list">
                                <div class="tab_cell tab_link" @click="showDrawer(3)">会员子女(每名)发生意外<br>事故导致身故残疾保障</div>
                                <div class="sLine"></div>
                                <div class="tab_cell">
                                    <div class="tab_cell lh30 bb1">残疾最高5000元</div>
                                    <div class="tab_cell lh30">身故20000元</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">所需提供材料</div>
                    <div class="arrow_box mb20">
                        <div class="arrow_title">
                            <div>事故发生后,通过单位工会申领互助金</div>
                            <div class="subTitle">(所需材料)</div>
                        </div>
                        <div>
                            <div class="materialTable">
                                <div class="materialRow">
                                    <div class="left">申请材料</div>
                                    <div class="right">《互助金申请书》<span style="color:#999; font-size:12px">
                                            (请联系单位工会)</span>
                                        <br>
                                        身份证复印件<br>
                                        “工会会员互助服务卡”复印件
                                    </div>
                                </div>
                                <div class="materialRow">
                                    <div class="left">认定材料</div>
                                    <div class="right">
                                        <span
                                            class="bold">1、伤残程度证明:</span>二级(含)以上医疗机构出具的伤残程度证明。如果会员自遭受意外伤害之日起180日治疗仍未结束,则按照第180日的身体伤残状况出具相应证明<br>
                                        <span class="bold">2、身故互助金需户口注销证明和死亡证明</span><br>
                                        <span class="bold">3、火灾损失互助金需:</span>
                                        <span class="tab_link"
                                            @click="showImgBtn(0)">《火灾事故认定书》</span>、房屋产权证与产权相关的证明文件复印件<br>
                                        <span class="bold">4、家庭财产水暖管爆裂损失保障:</span>根据物业或居委会出具的相关证明,对受损面积领取互助金
                                        <span class="tab_link" @click="showImgBtn(1)">《参考样表》</span><br>
                                        <span
                                            class="bold">5、其它必要文件或证明:</span>包括二级(含)以上医疗机构出具的诊断证明、检查报告单、入院记录住院病历、手术记录、出院记录;户口本复印件、会员子女《出生医学证明》等关系证明;《学生证》等在校证明;交通部门出具的《道路交通事故认定书》;家庭财产损失事故现场照片、维修记录等
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">温馨提示</div>
                    <div class="desc mb20">
                        1、保险责任期是以自然年度为一个互助保障责任期,即本年度出险需于本年度申领,若遇年底特殊情况,以系统录入日期为准。<br>
                        2、事故发生10日内告知单位工会。事故发生两年内未提交互助金申请手续,视为放弃。
                    </div>
                </div>
                <!--  -->
                <div>
                    <div class="title mb20">咨询电话</div>
                    <footerTel tel="010-83570059"></footerTel>
                </div>

                <div class="footer ">本页面仅供参考,具体以北京市职工互助保障服务中心公示细则为准</div>
            </div>
        </div>
        <!-- 弹层 -->
        <el-drawer :title="titleList[ImageIndex].title" size="60%" custom-class="custom-class" :visible.sync="drawer"
            :direction="direction">
            <div class="drawer_box">
                <div v-for="(item, index) in titleList" :key="index" v-show="ImageIndex == index">
                    <img :src="item.src" alt="" class="drawer_img">
                </div>

            </div>
        </el-drawer>
        <!--  -->
        <!-- <div class="imgMaskBox trans" v-show="showImg"> -->
        <div class="imgMaskBox trans" :class="{ 'active': showImg }">
            <div class="imgWarpper">
                <div class="img_box">
                    <img src="../../assets/special/b1.jpg" alt="" class="mobileImg" v-show="showImaIndex == 0">
                    <img src="../../assets/special/b2.jpg" alt="" class="mobileImg" v-show="showImaIndex == 1">
                </div>
                <div class="close_btn" @click="closeImg">
                    <i class="el-icon-circle-close"></i>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
// import banner from "../../components/banner.vue"
import MaskLoading from "@/components/maskLoading.vue";
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
import footerTel from "@/components/specialFooterTel.vue"
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {
            isShow: true,
            drawer: false,
            showImg: false,
            direction: 'btt',
            ImageIndex: 0,
            showImaIndex: 0,
            titleList: [{
                title: "家庭财产火灾损失保障",
                src: require("../../assets/special/j1.jpg")
            }, {
                title: "家庭财产水暖管爆裂损失保障",
                src: require("../../assets/special/j2.jpg")
            }, {
                title: "会员本人",
                src: require("../../assets/special/j3.jpg")
            }, {
                title: "会员子女",
                src: require("../../assets/special/j4.jpg")
            }],
            bannerList: [
                { "src": require("@/assets/special/baoxiao.jpg") },
                // { "src": require("@/assets/special/baoxiao.jpg") }
            ],
        }
    },
    components: {
        // banner,
        MaskLoading,
        backSpecial,
        footerTel
    },
    mounted() {
        setTimeout(() => {
            this.isShow = false;
        }, 200)
    },
    methods: {
        showDrawer(index) {
            this.drawer = true;
            this.ImageIndex = index;
        },
        closeImg() {
            this.showImg = false;
        },
        showImgBtn(index) {
            this.showImaIndex = index;
            this.showImg = true;
        }
    },
    activated() {
        window.scrollTo(0, 0);
    },
    deactivated() {
        this.drawer = false;
    }
}
</script>

<style lang="less" scoped>
@import url(../../styles/specialDetail.less);

.specialDetaidBox {
    .table_box {

        border: 1px solid #eaeff3;
        overflow: hidden;

        .tab_title_box {
            display: flex;
            flex-wrap: wrap;

            .tab_title {
                flex: 1;
                text-align: center;
                background-color: #EDEFF3;
                // line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                border-left: 1px solid #ededed;
                border-bottom: 1px solid #ededed;
                margin-left: -1px;
                padding: 10px 0;
            }
        }


        .table_info_box {
            // display: flex;
            // flex-wrap: wrap;

            .tab_cell {
                flex: 1;
                font-size: 14px;
                text-align: center;
            }

            .row_list {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                width: 100%;
                height: 60px;
                border-bottom: 1px solid #ededed;
                margin-bottom: -1px;
            }

            .sLine {
                width: 1px;
                background-color: #ededed;
                height: 60px;
            }

            .bb1 {
                // border-bottom: 1px solid #ededed;
                box-sizing: border-box;
            }

        }



    }

    .subTitle {
        font-size: 12px;
        color: #999;
        font-weight: normal;
    }

    .materialTable {
        .materialRow {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            align-items: center;
            border-bottom: 1px solid #efefef;
            margin-bottom: -1px;
            line-height: 22px;

            .left {
                width: 80px;
                text-align: center;

            }

            .right {
                flex: 1;
                padding: 10px;
                border-left: 1px solid #efefef;
            }

            .bold {
                font-weight: bold;
            }
        }
    }

    // 
    .imgMaskBox {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: -1;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(1.15);
        opacity: 0;

        .close_btn {
            margin-top: 20px;
            text-align: center;
            color: #fff;
            font-size: 30px;
        }
    }

    // 激活状态
    .active {
        transform: scale(1);
        opacity: 1;
        z-index: 99;
    }
}
</style>